import { render, staticRenderFns } from "./PagamentoEntrega.vue?vue&type=template&id=a47d4962"
import script from "./PagamentoEntrega.vue?vue&type=script&lang=js"
export * from "./PagamentoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports